export default {
      id: "leaf-4-usage",
      viewBox: "0 0 100 30",
      url: __webpack_public_path__ + "/gfx/iconset.13.17.6.svg#leaf-4",
      toString: function () {
        return this.url;
      }
    }